import React, { Component } from 'react';
import { Menu } from 'element-react';
import './EmailCard.css';

class EmailCard extends React.Component {
  onOpen() {}

  render() {
    const { fullName, message, createdAt, email } = this.props;
    const formattedDate = `
        ${new Date(createdAt).getDate()}/${new Date(createdAt).getMonth()+1}/${new Date(createdAt).getFullYear()}
        a las ${('0' + new Date(createdAt).getHours()).slice(-2)}:${('0' + new Date(createdAt).getMinutes()).slice(-2)}
      `;

    return (
      <div className="cardWrapper">
        <div className="headerCard">
          <h3>Nom: {fullName}</h3>
          <h5>{formattedDate}</h5>
        </div>
        <p>Email: {email}</p>
        <p>
          Missatge:<br />
          {message}
        </p>
      </div>
    );
  }
}

export default EmailCard;



// WEBPACK FOOTER //
// ./src/components/EmailCard/EmailCard.js